export const isChatAnywhereEnabled = (locale: string | undefined) => {
    const allowedLocales = [
        'en-us',
        'en-gb',
        'en-ie',
        'en-ca',
        'en-au',
        'en-nz',
        'en-sg',
        'fr-fr',
        'fr-ca',
        'fr-ch',
        'fr-be',
        'de-de',
        'de-at',
        'de-ch',
        'it-ch',
        'it-it',
        'es-es',
        'es-us',
        'da-dk',
        'fi-fi',
        'nb-no',
        'sv-se',
        'nl-be',
        'nl-nl',
    ];
    // Enabling Chat Anywhere for the allowed locales and all devices
    if (locale && allowedLocales.includes(locale.toLowerCase())) return true;
    return false;
};
